var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('el-row',[_c('h2',[_vm._v("超级管理员")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }